import moment from 'moment';
import Moment from 'moment';

export let placeAddresCompoponent = {
  ZIP_CODE: 'postal_code',
  COUNTRY: 'country',
  STATE: 'administrative_area_level_1',
  CITY: 'administrative_area_level_2',
  TOWN: 'sublocality_level_1',
  AREA: 'sublocality_level_2',
  NEAREST_ROAD: 'route',
};
export function getAddressComponent(address_components: any, key: any) {
  let value = '';
  let postalCodeType = address_components.filter((aComp: any) =>
    aComp.types.some((typesItem: any) => typesItem === key)
  );
  if (postalCodeType != null && postalCodeType.length > 0) value = postalCodeType[0].long_name;
  return value;
}

export function formatDateTime(date: any, format: any) {
  Moment.locale('en');
  return Moment(date).format(format);
}

export function addHours(date?: any, hour?: any) {
  return Moment(date).add(hour, 'hours').toDate();
}
export function addDays(date?: any, day?: any) {
  return Moment(date).add(day, 'days').toDate();
}

export function isWhatPercentOf(x: any, y: any) {
  if (x == 0 || y == 0) {
    return 0;
  }
  else {
    return (x / y) * 100;
  }
}

export function calculateDistance(lattitude1: any, longittude1: any, lattitude2: any, longittude2: any) {
  const toRadian = (n: any) => (n * Math.PI) / 180;

  let lat2 = lattitude2;
  let lon2 = longittude2;
  let lat1 = lattitude1;
  let lon1 = longittude1;

  let R = 6371; // km
  let x1 = lat2 - lat1;
  let dLat = toRadian(x1);
  let x2 = lon2 - lon1;
  let dLon = toRadian(x2);
  let a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;
  return d.toFixed(2);
}

export function getInitials(value: any) {
  if (value) {
    return value
      .match(/\b(\w)/g)
      .join('')
      .toUpperCase();
  }
}

export let GET_DAYS: any = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday',
};

export let GET_REVENUE_TABDATA: any = {
  0: 'day',
  1: 'week',
  2: 'month',
};

export function formatPhoneNumber(phoneNumberString: any) {
  let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    let intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export function roundNumber(value: number) {
  return Math.round((value + Number.EPSILON) * 100) / 100;
}
export function getStartDate(type: any, date?: Date) {
  //Moment.locale('en');
  if (date) {
    return Moment(date).startOf(type).format('YYYY-MM-DDTHH:mm:SS');
  } else {
    return Moment().startOf(type).format('YYYY-MM-DDTHH:mm:SS');
  }
}

export function getEndDate(type: any, date?: Date) {
  Moment.locale('en');
  if (date) {
    return Moment(date).endOf(type).format();
  } else {
    return Moment().endOf(type).format();
  }
}

export function onlyLastFourDigits(num: any) {
  let str = num;
  let replaced = str.replace(/.(?=.{3,}$)/g, '*');
  return replaced;
}

export function splitName(value: string) {
  let string = value;
  let splittingValue1 = string.split('/');
  let arraySplittedValue1 = splittingValue1[3];
  let mainValueSplit = arraySplittedValue1.split('-');
  let mainSplittedValue = mainValueSplit[3];
  return mainSplittedValue;
}
export function formatSSNNumber(phoneSSNString: any) {
  let cleaned = ('' + phoneSSNString).replace(/\D/g, '');
  let match = cleaned.match(/^(\d{3})(\d{3})(\d{3})$/);
  if (match) {
    let intlCode = match[11];
    return [intlCode, match[1], '-', match[2], '-', match[3]].join('');
  }
  return null;
}
export function formatEINNumber(phoneEINString: any) {
  let cleaned = ('' + phoneEINString).replace(/\D/g, '');
  let match = cleaned.match(/^(\d{2})(\d{7})$/);
  if (match) {
    let intlCode = match[12];
    return [intlCode, match[1], '-', match[2]].join('');
  }
  return null;
}

export function last4Character(value: string) {
  let val = value;
  let fourChar = val.substring(val.length - 4);
  return fourChar;
}

export function last4CharacterSsn(value: string) {
  let val = value;
  let replaceAbleStr = val.split('-').join('');
  let fourChar = replaceAbleStr.substring(replaceAbleStr.length - 4);
  return fourChar;
}
export function onlyLastFourNum(value: any) {
  if (value !== undefined && value !== null) {
    let replaced = value.replace(/.(?=.{4,}$)/g, '*');
    return replaced;
  } else {
    return '';
  }
}
export function onlyLastEmailShow(value: any) {
  if (value !== undefined && value !== null) {
    let replaced = value.replace(/.(?=.{13,}$)/g, '*');
    return replaced;
  } else {
    return '';
  }
}
export function checkPermissions(permissionArray: Array<string>, userPermissionArray: Array<string>) {
  return userPermissionArray.some((item: string) => permissionArray.indexOf(item) > -1);
}

export function capitalName(value: any): string {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1);
}
export function changeCase(value: any) {
  return value.toUpperCase();
}

export function formatTime(actualCheckinTime: any, actualCheckoutTime: any, bookingStatus: any) {
  if (actualCheckinTime !== null && actualCheckoutTime == null && bookingStatus == 'booked') {
    const date1 = new Date();
    const date2 = new Date(actualCheckinTime);
    const diff = date1.getTime() - date2.getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    return hh + ':' + mm + ':' + ss;
  } else if (
    (actualCheckinTime !== null && actualCheckoutTime !== null && bookingStatus == 'Completed') ||
    bookingStatus == 'Checkout'
  ) {
    const date1 = new Date(actualCheckoutTime);
    const date2 = new Date(actualCheckinTime);
    const diff = date1.getTime() - date2.getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    return hh + ':' + mm + ':' + ss;
  }
}

export function timeInMiliseconds(actualCheckinTime: any, actualCheckoutTime: any, bookingStatus: any) {
  if (actualCheckinTime !== null && actualCheckoutTime == null && bookingStatus == 'booked') {
    const date1 = new Date();
    const date2 = new Date(actualCheckinTime);
    const diff = date1.getTime() - date2.getTime();
    return diff;
  } else if (actualCheckinTime !== null && actualCheckoutTime !== null && bookingStatus == 'Completed') {
    const date1 = new Date(actualCheckoutTime);
    const date2 = new Date(actualCheckinTime);
    const diff = date1.getTime() - date2.getTime();
    return diff;
  }
}

export function extraBookingHour(actualCheckinTime: any, actualCheckoutTime: any, bookingStatus: any) {
  if (actualCheckinTime !== null && actualCheckoutTime !== null && bookingStatus == 'Completed') {
    const date1 = new Date(actualCheckoutTime);
    const date2 = new Date(actualCheckinTime);
    const diff = date1.getTime() - date2.getTime();
    let msec = diff;
    const hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    const mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    const ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    return hh * 1000 * 60 * 60;
  }
}

export function formatTimeHHMM(date: any, format: any) {
  Moment.locale('en');
  date = date.split('+')[0];
  return Moment(date).format(format);
}

export function getUTCTime(date: Date) {
  const utcDate = Moment.utc(date).format('HH:mm');
  return utcDate;
}

export function getISTTime(date: Date) {
  const utcDate = Moment(date).format('HH:mm');
  return utcDate;
}

export function getUniqueKey() {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
}
